export default {"src":"/_next/static/media/arrow-left-long.6c63e864.svg","height":24,"width":24};